import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ClassSectionService from "../../services/getstandardsection.service";

/* ---------------- FETCH STANDARD + SECTION MAPPING ---------------- */
export const fetchStandardSection = createAsyncThunk(
  "classsection/fetchStandardSection",
  async (payload, thunkAPI) => {
    try {
      const response =
        await ClassSectionService.getStandardsBySection(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* ---------------- ADD ---------------- */
export const addclassandsection = createAsyncThunk(
  "classsection/addClassandsection",
  async (data, thunkAPI) => {
    try {
      const response = await ClassSectionService.addClassandsection(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* ---------------- UPDATE ---------------- */
export const updateClassandsection = createAsyncThunk(
  "classsection/updateClassandsection",
  async (payload, thunkAPI) => {
    try {
      const response = await ClassSectionService.editClassandsection(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* ---------------- INITIAL STATE ---------------- */
const initialState = {
  loading: false,
  error: null,
  classsectionList: [],
  selectedclasssection: null,
  updateSuccess: false,
};

/* ---------------- SLICE ---------------- */
const classsectionSlice = createSlice({
  name: "classsection",
  initialState,

  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      /* ---------- FETCH ---------- */
      .addCase(fetchStandardSection.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStandardSection.fulfilled, (state, action) => {
        state.loading = false;
        state.classsectionList = action.payload?.data || [];
      })
      .addCase(fetchStandardSection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- ADD ---------- */
      .addCase(addclassandsection.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(addclassandsection.fulfilled, (state) => {
        state.loading = false;
        state.updateSuccess = true;
      })
      .addCase(addclassandsection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- UPDATE ---------- */
      .addCase(updateClassandsection.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateClassandsection.fulfilled, (state) => {
        state.loading = false;
        state.updateSuccess = true;
      })
      .addCase(updateClassandsection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = classsectionSlice.actions;
export default classsectionSlice.reducer;
